import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { roulette } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A ROULETTE TABLE, NO CARDS AND EVERY STAKE IN ONE COLUMN */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={roulette.api} config={roulette} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
